import { addDays, startOfDay } from 'date-fns';
import { formatDateLong } from '~/lib/DateTime';
import { useIsWaitlistEnabled } from '~/components/waitlist/AddToWaitlistModal.jsx';

const NoAvailableClasses = ({
    onViewDate,
    nextAvailableDate,
    nextAvailableWaitlist,
    settings,
    className,
}) => {
    const isWaitlistEnabled = useIsWaitlistEnabled(settings);

    return (
        <div className={`text-center ${className}`}>
            <div className="text-lg mb-2 mt-6 font-medium">
                {!nextAvailableDate && (
                    <>There is no availability for the next month</>
                )}
                {!!nextAvailableDate && (
                    <>
                        Next available is on {formatDateLong(nextAvailableDate)}
                    </>
                )}
            </div>
            {!!nextAvailableDate && (
                <button
                    type="button"
                    className="form-button"
                    onClick={() => onViewDate(new Date(nextAvailableDate))}
                >
                    Go to next available
                </button>
            )}
            {!!nextAvailableWaitlist && isWaitlistEnabled && (
                <div className="mt-4">
                    <a
                        href="#"
                        className="no-underline"
                        onClick={ev => {
                            ev.preventDefault();
                            onViewDate(new Date(nextAvailableWaitlist));
                        }}
                    >
                        Or, join the waitlist for{' '}
                        {formatDateLong(nextAvailableWaitlist)}
                    </a>
                </div>
            )}
        </div>
    );
};

export default NoAvailableClasses;
